// extracted by mini-css-extract-plugin
module.exports = {"svgColor":"Icons_svgColor__R0i09","hoverable":"Icons_hoverable__1PGE-","hovered":"Icons_hovered__33_zv","active":"Icons_active__239Cp"};